import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import jsPDF from "jspdf";

import DateTimePicker from "../../../components/formElements/datepicker/DateTimePicker";
import EarningReportsList from "./EarningReportsList";

import * as actions from "../../../store/actions";
import { useInfiniteScroll } from "../../../utils/pagination";

import "./index.css";
import SearchBox from "../../../components/formElements/searchbox/SearchBox";

const EarningReports = ({
  getPaymentDetails,
  earningReports,
  total_pages,
  totalEarnings,
  searchData,
  searchValue,
  searchEarningReports,
  emptyEarningReports,
}) => {
  const [page, setPage] = React.useState(0);

  const [date, setDate] = useState([
    moment().subtract(1, "month").toDate(),
    new Date(),
  ]);

  const [startDate, endDate] = date;

  const loader = useRef(null);

  useInfiniteScroll(loader, () => setPage((page) => page + 1));

  const inputValue =
    startDate && endDate
      ? moment(`${startDate}`).format("MMM DD") +
        " - " +
        moment(`${endDate}`).format("MMM DD")
      : moment(`${startDate}`).format("MMM DD");

  useEffect(() => {
    if (page > 0 && !searchValue && page <= total_pages && startDate && endDate) {
      getPaymentDetails(startDate, endDate, "", page);
    }
  }, [page, searchValue, endDate, startDate]);

  useEffect(() => {
    emptyEarningReports();
    // eslint-disable-next-line
  }, []);

  const handleGeneratePDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(16);
    doc.text("Earning Reports", 14, 20);
    doc.setFontSize(12);

    // Add table headers
    doc.text("Patient Name", 14, 30);
    doc.text("Date", 100, 30);
    doc.text("Amount", 160, 30);

    // Populate table rows
    earningReports.forEach((report, index) => {
      const y = 40 + index * 10;
      doc.text(`${report?.first_name} ${report?.last_name}`, 14, y);
      doc.text(
        moment(report?.created_at || new Date()).format("YYYY-MM-DD"),
        100,
        y
      );
      doc.text(`$${report?.amount || 0}`, 160, y);
    });

    // Save the PDF
    doc.save("Earning_Reports.pdf");
  };

  return (
    <div>
      <p className="text-dark h5 mb-4 font-weight-bold">Earning Reports</p>
      <div className="pl-5 earning-report-header">
        <div className="text-right mt-4">
          <span className="earnings-for">Earnings For</span>
          <p
            className="mt-3"
            style={{
              cursor: "pointer",
            }}
          >
            <DateTimePicker
              calendarType="multiSelect"
              value={inputValue}
              placeholder="Select date"
              className="w-auto"
              startDate={startDate}
              endDate={endDate}
              onChange={(value) => {
                setDate(value);
                setPage(1);
              }}
            />
          </p>
        </div>
        <div className="earning-report-border-right mx-4"></div>
        <span
          className="font-weight-bold"
          style={{
            fontSize: 30,
          }}
        >
          ${totalEarnings}
        </span>

        <div className="searchBoxes ml-auto">
          <SearchBox
            value={searchValue}
            onChange={(val) => {
              searchEarningReports(val);
              setPage(1);
            }}
          />
        </div>

        {earningReports?.length > 0 && (
          <span className="ml-auto px-3 print-report">
            <button onClick={handleGeneratePDF} className="download-pdf-btn">
              Print Report
            </button>
          </span>
        )}
      </div>
      <EarningReportsList
        earningReports={earningReports}
        searchValue={searchValue}
        searchEarningReports={searchData}
        onChange={(val) => {
          searchEarningReports(val);
          setPage(1);
        }}
      />
      <div ref={loader}></div>
    </div>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  earningReports: dashboard.earningReports?.earningReports,
  total_pages: dashboard.earningReports.total_pages,
  totalEarnings: dashboard.earningReports.totalEarning,
  searchData: dashboard?.earningReports?.searchEarningReports,
  searchValue: dashboard.earningReports?.searchEarningReportsValue,
});

const mapDispatchToProps = (dispatch) => ({
  getPaymentDetails: (startDate, endDate, q, page) =>
    dispatch(actions.getPaymentDetails(startDate, endDate, q, page)),
  searchEarningReports: (q) => dispatch(actions.searchEarningReports(q)),
  emptyEarningReports: () => dispatch(actions.emptyEarningReports()),
});

export default connect(mapStoreToProps, mapDispatchToProps)(EarningReports);
